import { KioskResource } from './KioskResource';

export class ClientFaqAndKioskResource {
    rid: number;
    kiosk: KioskResource;
}